import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    background: theme.palette.blue.light100,
    '& .MuiAccordion-root.Mui-expanded': {
      margin: '0 !important',
    },
    '& .MuiAccordionSummary-expandIcon .collapseIconWrapper': {
      display: 'none',
    },
    '& .MuiAccordionSummary-expandIcon': {
      transform: 'none',
    },
    '& .MuiAccordionSummary-expandIcon.Mui-expanded .expandIconWrapper': {
      display: 'none',
    },
    '& .MuiAccordionSummary-expandIcon.Mui-expanded .collapseIconWrapper': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
    },
  },
  maxWidthContainer: {
    width: '100%',
    maxWidth: 1440,
    paddingBottom: 16,
    margin: '0 auto',
  },
  introContainer: {
    padding: '42px 32px 16px',
  },
  heading: {
    ...theme.typography.h2,
    color: theme.palette.secondary.light,
    marginBottom: 20,
    marginTop: 12,
  },
  supportiveCopy: {
    maxWidth: 732,
    margin: 0,
  },
  ctaContainer: {
    flex: 1,
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
  },
  accordion: {
    background: 'transparent',
    boxShadow: 'none',
    '&:before': {
      display: 'none',
    },
    '&:last-child .MuiAccordionSummary-root ': {
      borderBottom: 'none !important',
    },
    '&.Mui-expanded': {

    },
  },
  accordionTitle: {
    ...theme.typography.h6,
    color: '#6A6A6A',
    background: 'transparent',
    boxShadow: 'none',
    padding: '12px 0',
    margin: '0 34px',
    display: 'flex',
    alignItems: 'center',
    borderBottom: '1px solid #D8D8D8',
    '&.Mui-expanded': {
      color: theme.palette.secondary.light,
    },
    '& .scenic-accordion-list-icon': {
      background: '#D8D8D8',
    },
    '&.Mui-expanded .scenic-accordion-list-icon': {
      background: theme.palette.gold.main,
    },
    '& .MuiAccordionSummary-content': {
      alignItems: 'center',
    },
  },
  titleIcon: {
    borderRadius: '50%',
    width: 36,
    height: 36,
    flexBasis: 36,
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 16,
  },
  accordionDetails: {
    padding: 0,
    background: 'transparent',
    boxShadow: 'none',
  },
}))

export default useStyles
